








































































































import {
  computed,
  defineComponent,
  ref,
} from '@vue/composition-api';
import type { Ref } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import type { PaginatorInfo } from '@/types/paginatorInfo';
import areaCode from '@/table/setting/areaCode/areaCode';
import areaCodeDetail from '@/table/setting/areaCode/detail';
import useAuth from '@/useAuth';

import getAreaCodes from '@/gql/areaCode/getAreaCodes.gql';
import updateAreaCode from '@/gql/areaCode/updateAreaCode.gql';
import deleteAreaCode from '@/gql/areaCode/deleteAreaCode.gql';
import getHubs from '@/gql/company/getHubs.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const AreaCode = defineComponent({
  components: {
    CommonModalWithPreset,
    PrettyCheck,
  },
  setup() {
    const { me } = useAuth();
    const search: Ref<string> = ref('');
    const searchHub: Ref<any> = ref(null);
    const isExpand: Ref<boolean[]> = ref([]);
    const getAreaCodesResult = (data: any) => data.areasPaginate;
    function resetExpand(paginatorInfo: PaginatorInfo) {
      isExpand.value = [...Array.from({ length: paginatorInfo.count }, () => false)];
    }
    const forceRender = ref(true);
    function pendingExpand(index: number) {
      forceRender.value = false;
      isExpand.value[index] = !isExpand.value[index];
      forceRender.value = true;
    }
    // ==== Use to search User ==== //
    const getAreaCodesVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filter: undefined,
        filterHub: undefined,
      };
      if (me.hub.hubType !== 'MAIN' || searchHub.value) {
        vars.filterHub = {
          column: 'ID',
          value: searchHub.value?.id || me.hubId,
        };
      }
      if (search.value) {
        vars.filter = {
          OR: [
            {
              column: 'CODE',
              operator: 'LIKE',
              value: `%${search.value}%`,
            },
            {
              column: 'NAME',
              operator: 'LIKE',
              value: `%${search.value}%`,
            },
          ],
        };
      }
      return vars;
    });

    // =============================================
    // ===== Use to delete AreaCode from system =====
    // =============================================
    const refetchQueries = ['getAreaCodes', 'getAllAreaCodes', 'getProducts', 'getProduct'];
    const deleteAreaCodeModal = ref(null);
    const deleteAreaCodeMutation = useMutation(deleteAreaCode, {
      refetchQueries,
    });
    function deleteAreaCodeAction(areaCodeId: number) {
      deleteAreaCodeMutation.mutate({
        id: areaCodeId,
      });
    }

    function calculateUniqueItem(row: any, key = 'province', resultKey = 'id') {
      const arr = row.item.location?.map((loc: any) => loc[key][resultKey]);
      return (new Set(arr)).size;
    }

    const updateAreaCodeMutation = useMutation(updateAreaCode, () => ({
      refetchQueries,
    }));

    return {
      search,

      me,
      getHubs,
      searchHub,
      pendingExpand,
      forceRender,
      isExpand,
      resetExpand,
      getAreaCodesResult,
      getAreaCodesVariables,
      getAreaCodesQuery: getAreaCodes,
      areaCodesTableOptions: areaCode,
      areaCodeDetail,
      calculateUniqueItem,

      deleteAreaCodeModal,
      deleteAreaCodeAction,
      updateAreaCodeMutation,
    };
  },
});

export default AreaCode;
